export default "__VITE_PUBLIC_ASSET__5e854140__"